import { Box } from '@mantine/core';
import { memo, ReactNode } from 'react';

import { ListItemHelpers } from './List';

interface ListItemProps<T> {
  item: T;
  index: number;
  helpers: ListItemHelpers<T>;
  children: (item: T, index: number, helpers: ListItemHelpers<T>) => ReactNode;
}

const ListItemComponent = <T,>({ item, index, helpers, children }: ListItemProps<T>) => {
  return <Box>{children(item, index, helpers)}</Box>;
};

export const ListItem = memo(ListItemComponent, (prev, next) => {
  // Only re-render if the item reference, index, or helper functions change
  return (
    prev.item === next.item &&
    prev.index === next.index &&
    prev.helpers.update === next.helpers.update &&
    prev.helpers.remove === next.helpers.remove &&
    prev.helpers.canRemove === next.helpers.canRemove
  );
}) as typeof ListItemComponent;
